/**
 * Public-text tab of the segment editor: the bulleted markdown the user posts publicly.
 *
 * This is the ONLY text Echo Hunt's corpus is built from (it never reads `longText`); see
 * `Docs/Plans/Others/2026-10-19_EchoHunt.md` §4.0 and `Source/EchoHunt/Bullets.ts`.
 *
 * Extracted from `SegmentUI.tsx` so the segment editor can switch between the three text fields.
 */
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Row, TextArea} from "react-vcomponents";
import {SegmentTextTabProps, UpdateSegmentTextField} from "./@Shared.js";

export const SegmentTextTab_PublicText = observer_mgl((props: SegmentTextTabProps)=>{
	const {segment} = props;
	return (
		<Row>
			<TextArea style={{border: "1px solid black"}} autoSize={true} value={segment.publicText ?? ""} onChange={val=>{
				UpdateSegmentTextField(props, "publicText", val);
			}}/>
		</Row>
	);
});
